import { ExecutionId } from "@mp-commons/modules/player/MediaResource.js";

export class ExecutionInfo {
    private _impression: boolean;
    private _completed: boolean;
    private _started: boolean;
    
    constructor(private _milestones: number[]) {
        this._impression = false;
        this._completed = false;
        this._started = false;
    }

    
    public get started() {
        return this._started;
    }

    public setStarted() {
        this._started = true;
    }

    public get impression() {
        return this._impression;
    }
    public setImpression() {   
        this._impression = true;
    }

    public get completed() {
        return this._completed;
    }
    public setCompleted() {   
        this._completed = true;
    }

    public extractProgressMilestone(prog: number): number {
        if(this._milestones.length > 0 && this._milestones[0] <= prog) {
            return this._milestones.shift();
        }
        else return -1;
    }


}


export class VolatileExecutionData {

    private executions: {[k: ExecutionId]: ExecutionInfo};
    private milestones: number[];

    constructor(milestones: number[] = [0,25,50,75,90]) {
        this.milestones = milestones.sort((a,b) => a - b)
        this.executions = {};
    }


    getExecutionInfo(id: ExecutionId): ExecutionInfo  {
        if(!(id in this.executions)) {
            this.executions[id] = new ExecutionInfo(this.milestones);
        }
        return this.executions[id];
    }

}